import React from 'react'
import { Navbar, NavbarBrand } from 'react-bootstrap';
import {NavLink} from 'react-router-dom'
import Home from '../HomePage/Home';


export default function Header() {
    return (
        <div>
            <Navbar className="bg-primary">
                <NavLink to="/home" className = "text-white text-decoration-none ms-3 px-3 border-end border-3" activeClassName="selected">
                    Home
                </NavLink>
                <NavLink to="/about" className = "text-white text-decoration-none ms-3 px-3 border-end border-3" activeClassName="selected">
                    About
                </NavLink>
                <NavLink to="/courses" className = "text-white text-decoration-none ms-3 px-3 border-end border-3" activeClassName="selected">
                    Courses
                </NavLink>
                <NavLink to="/instructors" className = "text-white text-decoration-none ms-3" activeClassName="selected">
                    Instructors
                </NavLink>
            </Navbar>
        </div>
    )
}
